import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Chip, Box, Skeleton } from "@mui/material";

const StatusCard = ({ auditTrail, processStatus }) => {
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [actionDate, setActionDate] = useState(new Date())

  const createStatusData = (auditTrail, processStatus) => {
    let status = "", message = "", name = ""; 
    let dateStartedVal = new Date()
    
    if (auditTrail?.length && processStatus?.length) {
      const findFirstSeq = processStatus[0];
      const findSecondSeq = processStatus[1];
      const lastStatus = auditTrail[auditTrail.length - 1];
      const { ID } = findFirstSeq;
      const { AllowedRole, finalStatus, CurrentProcessID, Status, dateStarted , StatusName} = lastStatus;
      dateStartedVal = dateStarted

      // Action Required
      if (AllowedRole?.includes("user") && finalStatus === "Submitted" && Status.includes("Return")) {
        const { Remarks, peformedByName } = lastStatus;
        status = "Returned to Employee";
        message = Remarks;
        name = peformedByName;
      } else if (["BenefitsGovernmentWideManagement","BenefitsDepartmentManagement","BenefitsGovernmentWideManagement,BenefitsDepartmentManagement"].includes(AllowedRole) && finalStatus === "Benefit Action Required") {
        const { Remarks, peformedByName } = lastStatus;
        status = "Action Required";
        message = Remarks;
        name = peformedByName;
      }

      // Approval
      if (Status.includes("Approved") && CurrentProcessID > findSecondSeq?.ID && StatusName !="Benefit Action Required") {
        const { Remarks, peformedByName } = lastStatus;
        status = "Approved";
        message = Remarks;
        name = peformedByName;
      }

    //   return { status, message, name };
    console.log(auditTrail, processStatus,status, message, name, AllowedRole,finalStatus,'processStatus1221')

    }

    return { status, message, name, dateStarted : dateStartedVal };
    
  };

  useEffect(() => {
    const { status, message, name, dateStarted } = createStatusData(auditTrail, processStatus);
    setStatus(status);
    setMessage(message);
    setName(name);
    setActionDate(dateStarted)
    setLoading(false);
  }, [auditTrail, processStatus]);

  const getStatusChip = () => {
    if(status === "Returned to Employee"){
      return (
        <Chip
          label="Returned to Employee"
          style={{ backgroundColor: "#f44336", color: "#fff" }}
        />
      );
    }else if (status === "Action Required") {
      return (
        <Chip
          label="Action Required"
          style={{ backgroundColor: "#f44336", color: "#fff" }}
        />
      );
    } else if (status === "Approved") {
      return (
        <Chip
          label="Approved"
          style={{ backgroundColor: "#4caf50", color: "#fff" }}
        />
      );
    }
    return null;
  };

  const formatDate = (timestamp) => {
    if(!timestamp) return ""
    const date = new Date(timestamp);

    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    return formattedDate
  };

  return (
    <>
    {name? 
    <Card style={{ backgroundColor: "#fff" }}>
    <CardContent>
      {loading ? (
        <>
          <Skeleton variant="rectangular" width={80} height={32} style={{ marginBottom: 16 }} />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="60%" />
        </>
      ) : (
        <>
        <div style={{marginBottom:"2px" , display:"flex", gap:"5px", alignItems:"center"}}>
        <Typography variant="body2" style={{ fontWeight: "bold" }} gutterBottom>
            {name}
          </Typography>
          <Box mb={1}>{getStatusChip()}</Box>
        </div>
          <Typography variant="body1" gutterBottom>
            Remarks-  {message}
          </Typography>
          <Typography variant="body2" color="textSecondary">
              {formatDate(actionDate)}
          </Typography>
        </>
      )}
    </CardContent>
  </Card>
    : ""}
    
    </>
  );
};

export default StatusCard;
